import { Button } from "antd";
import { useDesactivarCodigoPokemon } from "../../../../Hooks/Admin";
import { useQueryClient } from "react-query";
import { useState } from "react";




const DesactivarButton = ({ idCodigo, estado }) => {
  const apiDesactivar = useDesactivarCodigoPokemon(); // Ahora sí, dentro de un componente funcional
  const queryClient = useQueryClient()
  return (
    <Button
      type="primary"
      danger
      disabled={estado === "Desactivado"} // Deshabilitar si ya está desactivado
      onClick={async () => {
        try {
          const response = await apiDesactivar.mutateAsync({ idCodigo });

          if (response?.success) {
            //alert("Código desactivado correctamente");
            queryClient.invalidateQueries("listarCuponesPokemones");
            window.location.reload()
          } else {
            throw new Error(response?.message || "Error desconocido");
          }
        } catch (error) {
          console.error("Error:", error);
          alert("Hubo un problema al desactivar el código");
        }
      }}
    >
      Desactivar Código
    </Button>
  );
};


export const columns = [
  {
    title: "Codigo",
    dataIndex: "codigo",
    width: "20%",
  },
  {
    title: "ID Pokemon",
    dataIndex: "idPokemon",
    width: "5%",

  },
  {
    title: "Pokemon",
    dataIndex: "nombrePokemon",
    width: "20%",
  },
  {
    title: "Estado",
    dataIndex: "estado",
    width: "10%",
    render: (estado) => {
      const color = estado === "Activo" ? "green" : "red";
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: color,
            }}
          />
          {estado}
        </div>
      );
    },
  },
  {
    title: "Fecha Creación",
    dataIndex: "fechaCreacion",
    width: "30%",
    render: (fecha) => {
      if (!fecha) return "-";
      const fechaObj = new Date(fecha);
      return fechaObj.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },

  {
    title: "Desactivar",
    dataIndex: "idCodigo",
    width: "5%",
    render: (_, record) => <DesactivarButton idCodigo={record.idCodigo} estado={record.estado} />,

  },
];
export const formatData = (data) => {
  return {
    idZona: data.idZona,
    zona_nombre: data.nombre,
    zona_imagen: data.imagen,
    nombre: data.nombre,
    imagen: data.imagen,
    pokemones: [],
  };
};

export const camposFormulario = (pokemon = []) => ({
  title: "Cupones Pokemon",
  campos: [
    {
      name: "cantidad",
      label: "Cantidad",
      type: "number",
      max: 10,
      min: 1,
      rules: [
        {
          required: true,
          message: "La cantidad es obligatoria",
        },
      ],

    },
    {
      name: "pokemones",
      label: "Pókemon",
      type: "multiple",
      opciones: pokemon,
    },
  ],
});





export const camposFilter = {
  title: "Codigos Pokemon",
  campos: [
    {
      name: "codigo",
      type: "text",
      label: "Codigo",
    },
    {
      name: "pokemon",
      type: "text",
      label: "Pokemon",
    },
    {
      name: "mostrarTodos",
      type: "checkbox",
      label: "Listar todos",
      valuePropName: "checked",
    },
  ],
};
